import MultiBarChart from "../../components/_common/BarChart/MultiBarChart";
import Spinner from "../../components/_common/Spinner";

export interface InputProps {
    data: any,
    isloading: Boolean; 
  }
  
// const data1 = [
//   {
//     name: 'پذیرش', waitCount: 2, count: 4
//   },
//   {
//     name: 'تایید', waitCount: 1, count: 3
//   },
//   {
//     name: 'نمونه', waitCount: 2, count: 5
//   },
//   {
//     name: 'هزینه ',waitCount:3, count: 2
//   },
// ];
  const color = ["#11adbe","#27f1ae"]
  const legendLabel = [
    {
      name: 'waitCount', value:"در صف انتظار"
    },
    {
      name: 'count', value:"انجام شده"
    }
    
  ];

  const Statistics = ({data,isloading}:InputProps) =>{
    let chartData:any[]=[];
    let flag = false;

    const getChartData =()=>{
        data.map((item:any)=>{
          chartData.push({name:"پذیرش", waitCount:item.AdmitedWaitCount,count:item.AdmitedCount});
          chartData.push( {name:"تایید ", waitCount:item.AdmitConfirmWaitCount,count:item.AdmitConfirmCount});
          chartData.push({name:"نمونه", waitCount:item.SamplingWaitCount,count:item.SamplingCount});
          chartData.push({name:"هزینه", waitCount:item.CashierWaitCount,count:item.CashierCount});
        })

        chartData.map((item:any)=>{
          if(item.waitCount !==0 && item.count !==0) {
            flag = true;
            return;
          }
        })
      }
    return(
        <div className="tab-content-padding">
        {  
        isloading === false  && (
            getChartData(),
           
            <>
            { 
              flag &&(
              <MultiBarChart data={chartData} colors={color}  legendLabel={legendLabel}/>
             )
             } 
             {
              flag === false &&
              (<p className="empty-data">داده ای برای نمایش موجود نیست.</p>)
             }
             </>
            )
            
        }
        {
          isloading === true  && (
          <Spinner />
        )
        }
        </div>
            )
        
        }
        
    export default Statistics;